import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { IRole } from "../interfaces/ilogin";
import { UserService } from "../services/user.service";
import { Observable } from "rxjs";

@Injectable()
export class RolesResolver implements Resolve<IRole[]> {
    constructor(private userService: UserService) {
    }

    resolve(route: ActivatedRouteSnapshot): Observable<IRole[]> {
        return this.userService.getRoles();
    }
}
